import { render, staticRenderFns } from "./IT.vue?vue&type=template&id=1ce6c69d&"
import script from "./IT.vue?vue&type=script&lang=js&"
export * from "./IT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports